import { render, staticRenderFns } from "./resource-shipin.vue?vue&type=template&id=891e0c12&scoped=true&"
import script from "./resource-shipin.vue?vue&type=script&lang=ts&"
export * from "./resource-shipin.vue?vue&type=script&lang=ts&"
import style0 from "./resource-shipin.vue?vue&type=style&index=0&id=891e0c12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891e0c12",
  null
  
)

export default component.exports